import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { LandingPostService } from './services/landing-post.service';
import { DocumentService } from '../../../core/services/document.service';

@Injectable({ providedIn: 'root' })
export class LandingPostResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private landingPostService: LandingPostService,
    private documentService: DocumentService,
  ) {}
  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    //debugger;
    let pathsSpilt = this.documentService.currentPath.split('/');
    let path = pathsSpilt[pathsSpilt.length - 1];
    // alert(path);
    if ((path && path.startsWith('_')) || path.startsWith('qr_')) {
      return {
        details: await this.loadPostDetails(path),
        landingId: path,
        isQrCode: path.startsWith('qr_'),
      };
    } else {
      this.router.navigate(['/404']);
      return null;
    }
  }

  async loadPostDetails(landingId: string) {
    var res = await this.landingPostService.getDetails(landingId);

    if (res.result.isShouldRedirect) {
      this.documentService.location.href = res.result.url;
      return;
    }

    return res.result;
  }
}
